import type { BoxProps, UseDisclosureReturn } from "@chakra-ui/react";
import { Box, Button, Grid, Modal, ModalBody, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay, Collapse, useDisclosure, Icon } from "@chakra-ui/react";
import { faKey } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FormProvider } from "react-hook-form";
import { InputFormControl } from "../../components";
import { PasswordGenerator } from "../../components/PasswordGenerator";
import { useSetPasswordForm, useGetSetPasswordInfo } from "../../hooks/useSetPassword";

export interface SetPasswordFormProps extends BoxProps {
    userId: string
    onPasswordReset: () => void
}
export const SetPasswordForm = ({ userId, onPasswordReset, ...rest }: SetPasswordFormProps) => {
    const { form, submitHandler } = useSetPasswordForm(userId, onPasswordReset)
    const { control, formState: { isSubmitting, isValid }, setValue } = form
    const { isOpen, onToggle } = useDisclosure()
    const { data: passwordInfo } = useGetSetPasswordInfo()
    
    const handlePasswordGenerated = (password: string) => {
        setValue('password', password)
    }

    return <FormProvider {...form}>
        <Box as="form" onSubmit={submitHandler} {...rest}>
            <Grid gap={4}>
                <Box>
                    <Button 
                        variant="link" 
                        colorScheme="blue" 
                        onClick={onToggle}
                        mb={2}
                        size="sm"
                    >
                        <Icon as={FontAwesomeIcon} icon={faKey} mr={2} />
                        {isOpen ? 'Skrýt generátor hesla' : 'Použít generátor hesla'}
                    </Button>
                    <Collapse in={isOpen} animateOpacity>
                        <Box p={4} borderWidth={1} borderRadius="md" mb={4}>
                            <PasswordGenerator
                                rules={passwordInfo?.data?.passwordRules || {
                                    minLenght: 8,
                                    requireDigit: true,
                                    requireLowercase: true,
                                    requireUppercase: true,
                                    requireNonLetterOrDigit: false
                                }}
                                onPasswordGenerated={handlePasswordGenerated}
                                showValidation={true}
                                autoGenerate={false}
                            />
                        </Box>
                    </Collapse>
                </Box>
                
                <InputFormControl label="Heslo" type="password" name="password" isRequired control={control} w='100% !important' />

                <Button colorScheme="primary" type="submit" size='lg' isLoading={isSubmitting} isDisabled={!isValid}>Změnit heslo</Button>
            </Grid>
        </Box>
    </FormProvider>
}

export const SetPasswordModal = ({ userId, isOpen, onClose }: Omit<SetPasswordFormProps, 'onPasswordReset'> & UseDisclosureReturn) => {
    return <Modal isOpen={isOpen} onClose={onClose} isCentered>
        <ModalOverlay />

        <ModalContent >
            <ModalCloseButton />

            <ModalHeader>Změna hesla</ModalHeader>

            <ModalBody pb={6}>
                <SetPasswordForm userId={userId} onPasswordReset={onClose} w='100%' />
            </ModalBody>
        </ModalContent>
    </Modal>

}